import React, { createContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { Convert, DefaultArrayEmpty, FnAxios, FnDialog, I18n, formatNumber, getMonthDifference } from "utilities/utilities";
import InputNumberItem from "components/Input/InputNumber";
import { BtnAdd, BtnDelete } from "components/Button/ButtonAll";
import moment from "moment";
import DateRangeProject from "view/FrontEnd/Project/components/DateRange";
import { parseFloatCheckValue } from "view/Backend/IncomeExpenses/Ticket/fnTickit";
import { List as LINQ } from "linqts";

export default function SpendingPlanProgressDuration(props) {
    const {
        nYear,
        form,
        onAdd,
        onDelete,
        arrDuration = [],
        lstProjectSpendingPlanType = [],
        isPermission,
        dStart,
        dEnd,
        trigger,
        nMixPlanBudget,
        nProgressID,
    } = props;

    const DialogFn = FnDialog();
    const [nTrigger, setnTrigger] = useState(trigger);

    const handleChangeBudget = (nID) => {
        let _lstDuration = [];

        //#region เฉพาะกิจกรรม
        let nSum = 0;
        arrDuration.forEach(f => {
            // let nDiff = moment(form.getValues(`sEndMonth_SpendingPlan_${f.nID}`)).diff(moment(form.getValues(`sStartMonth_SpendingPlan_${f.nID}`)), "month");
            // let nBudget = 0;
            let _nBudget = parseFloatCheckValue(form.getValues(`nBudget_SpendingPlan_${f.nID}`));
            // if (!isNaN(nDiff) && _nBudget) {
            //     nBudget = (_nBudget * (nDiff + 1));
            // }
            //// nSum += nBudget;

            // ++ ปัญหาที่เจอล่าสุดคือ กรณีที่เลือกช่วงเดือนทีเดียว 3 เดือนกะว่าจะให้เพิ่มเดือนล่ะ 100 แต่ทีนี้มันไปจับ ว่า 300*3 เลย ผิด ต้องหาวิธี อาจจะต้องลองผิด การ * เดือนไปก่อน

            //#region ต้องหาวิธีที่จะบวกค่า กรณีที่ มีเดือนซ้ำกัน และ บวกเพิ่มของเดือนนั้นมาด้วย
            let dDateStart = moment(form.getValues(`sStartMonth_SpendingPlan_${f.nID}`)).year(nYear);
            let dDateEnd = moment(form.getValues(`sEndMonth_SpendingPlan_${f.nID}`)).year(nYear);
            let nMonthStart = parseInt(dDateStart.format("M"));
            let nMonthEnd = parseInt(dDateEnd.format("M"));
            _lstDuration.push({
                nID: f.nID,
                nMonthStart: nMonthStart,
                nMonthEnd: nMonthEnd,
                nBudget: _nBudget, //nBudget
            });
            //#endregion
        })
        //#endregion

        //#region ผลรวมทั้งหมด และต้องทีล่ะเดือน เพราะไม่มีค่าเก็บไว้ต้องหาใหม่เสมอ
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 1 && w.nMonthEnd >= 1).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 2 && w.nMonthEnd >= 2).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 3 && w.nMonthEnd >= 3).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 4 && w.nMonthEnd >= 4).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 5 && w.nMonthEnd >= 5).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 6 && w.nMonthEnd >= 6).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 7 && w.nMonthEnd >= 7).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 8 && w.nMonthEnd >= 8).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 9 && w.nMonthEnd >= 9).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 10 && w.nMonthEnd >= 10).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 11 && w.nMonthEnd >= 11).Sum(s => s.nBudget);
        nSum += new LINQ<any>(_lstDuration || []).Where(w => w.nMonthStart <= 12 && w.nMonthEnd >= 12).Sum(s => s.nBudget);
        //#endregion
        
        if (nSum > nMixPlanBudget) {
            DialogFn.Warning("ผลรวมจำนวนเงินต่อเดือน ห้ามเกินงบประมาณกิจกรรม " + formatNumber(nMixPlanBudget, 2), () => {
                form.setValue(`nBudget_SpendingPlan_${nID}`, null);
            }, () => {
                form.setValue(`nBudget_SpendingPlan_${nID}`, null);
            });
        }
    }

    //// const OnCheckDuplicate = (date, clone) => {
    ////     let isDuplicate = false;
    ////     clone.forEach(item => {
    ////         let start = moment(form.getValues("sStartMonth_SpendingPlan_" + item.nID)).year(nYear);
    ////         let end = moment(form.getValues("sEndMonth_SpendingPlan_" + item.nID)).year(nYear);
    ////         if (start.isValid && end.isValid) {
    ////             let isBetween = date.isBetween(start, end, undefined, "[]");
    ////             if (isBetween) {
    ////                 isDuplicate = true;
    ////                 return true;
    ////             }
    ////         }
    ////     });
    ////     return isDuplicate;
    //// }

    const OnCheckDuplicate = (date, clone, nID) => {
        let isDuplicate = false;
        clone.forEach(item => {
            let start = moment(form.getValues(`sStartMonth_SpendingPlan_${item.nID}`)).year(nYear);
            let end = moment(form.getValues(`sEndMonth_SpendingPlan_${item.nID}`)).year(nYear);
            if (start.isValid() && end.isValid()) 
            {
                // เริ่มต้น - สิ้นสุดของช่วงใหม่
                let newStart = moment(form.getValues("sStartMonth_SpendingPlan_" + nID)).year(nYear);
                let newEnd = moment(form.getValues("sEndMonth_SpendingPlan_" + nID)).year(nYear);
                // เงื่อนไขการทับซ้อนช่วง: ช่วงใหม่เริ่มก่อน end เดิม และสิ้นสุดหลัง start เดิม
                const isOverlap = newStart.isSameOrBefore(end) && newEnd.isSameOrAfter(start);
                if (isOverlap) {
                    isDuplicate = true;
                    return true;
                }
            }
        });
        return isDuplicate;
    };

    const handleOnChange = (e, nID, type) => {
        let isDuplicate = false;
        let clone = [...arrDuration].filter(f => f.nID !== nID);
        if (e) {
            let date = moment(e).year(nYear);
            isDuplicate = OnCheckDuplicate(date, clone, nID);
            handleChangeBudget(nID);
            if (isDuplicate) {
                DialogFn.Warning("ช่วงเวลาซ้ำ");
                if (type === "start") {
                    form.setValue("sStartMonth_SpendingPlan_" + nID, null);
                } else {
                    form.setValue("sEndMonth_SpendingPlan_" + nID, null);
                }
                //// setnTrigger(nTrigger + 1);
                setnTrigger(v=> v + 1);
            }
        }
    }

    return (
        <Grid item xs={12} md={12} container spacing={2}>
            <FormProvider {...form}>
                {(arrDuration ||[]).map((m, i) => {
                    return (
                        <Grid item container spacing={2} key={"key_duration_SpendingPlan_" + m.nID}  style={{ display: (m.nProgressID !== nProgressID ? 'none' : ''), }}>
                            <Grid item xs={12} md={7}>
                                <DateRangeProject
                                    NameStart={`sStartMonth_SpendingPlan_${m.nID}`}
                                    NameEnd={`sEndMonth_SpendingPlan_${m.nID}`}
                                    LabelStart={'เริ่มต้น'}
                                    LabelEnd={'สิ้นสุด'}
                                    nID={m.nID}
                                    //// required={true}
                                    required={m.nProgressID === nProgressID}
                                    nYearMapper={nYear}
                                    onChange={handleOnChange}
                                    minDate={dStart}
                                    maxDate={dEnd}
                                    nTrigger={trigger}
                                    disabled={!isPermission}
                                    form={form}
                                />
                            </Grid>
                            <Grid item xs={6} md={3}>
                                <InputNumberItem
                                    id={`nBudget_SpendingPlan_${m.nID}`}
                                    name={`nBudget_SpendingPlan_${m.nID}`}
                                    label={"จำนวนเงินต่อเดือน"}
                                    endAdornment={"บาท"}
                                    type={"Number"}
                                    //// required={true}
                                    required={m.nProgressID === nProgressID}
                                    IsComma={true}
                                    IsAllowScientific={false}
                                    maxDigits={2}
                                    ShowDigits={2}
                                    maxInteger={8}
                                    min={0}
                                    max={nMixPlanBudget}
                                    disabled={!isPermission}
                                    onChange={() => { handleChangeBudget(m.nID) }}
                                />
                            </Grid>
                            {isPermission &&
                                <Grid item xs={6} md={2}>
                                    <Grid container spacing={2}>
                                        {(arrDuration || []).length === i + 1 &&
                                            <Grid item>
                                                <BtnAdd
                                                    sColor="#00B393"
                                                    sColorHover="#009278"
                                                    id={`AddDurationSpendingPlan_${m.nID}`}
                                                    txt={'เพิ่มช่วงเวลา'}
                                                    IsCircleWithOutText
                                                    onClick={form.handleSubmit((e) => onAdd(m.nActivityID),(err) => {
                                                        document.getElementById(Object.keys(err)[0])?.focus();
                                                        console.log("err", err)
                                                    })}
                                                />
                                            </Grid>
                                        }
                                        {(arrDuration || []).filter(f=> f.nProgressID === nProgressID).length > 1 &&
                                            <Grid item>
                                                <BtnDelete
                                                    sColorHover="#d30d1e"
                                                    id={`DeleteDurationSpendingPlan_${m.nID}`}
                                                    IsCircleWithOutText
                                                    onClick={() => onDelete(m.nID)}
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    )
                })}
                <Grid item style={{ display: 'none', }}>
                    {isPermission &&
                        <BtnAdd
                            id={"AddDurationSpendingPlan"}
                            onClick={form.handleSubmit((e) => ()=>{},(err) => {
                                document.getElementById(Object.keys(err)[0])?.focus();
                                console.log("err", err)
                            })}
                        />
                    }
                </Grid>
            </FormProvider>
        </Grid>
    )
}